import React from "react";
import BookingLink from "../button/BookingLink";
import formatServiceDuration from "../../utils/formatServiceDuration";

const ServiceCard = ({ title, soins }) => {
  return (
    <article className="booking-service-card card">
      <div className="card-body">
        <h3 className="card-title">{title}</h3>
        <ul className="booking-service-list list-unstyled">
          {soins.products.map((soin, index) => {
            const durations = soin.prestations.map((prestation) =>
              formatServiceDuration(prestation.time)
            );
            const hasTimedDurations = soin.prestations.every(
              (prestation) => typeof prestation.time === "number"
            );

            return (
              <li key={index} className="booking-service-item card-text">
                <span className="card-label">{soin.title}</span>
                <span className="card-value">
                  {hasTimedDurations &&
                    `${durations.length > 1 ? "Durées" : "Durée"} : `}
                  {durations.join(" ou ")}
                </span>
              </li>
            );
          })}
        </ul>
        <div className="booking-service-card-footer">
          <BookingLink
            className="btn btn-outline-secondary"
            showExternalIcon
          >
            Réserver sur Planity
          </BookingLink>
        </div>
      </div>
    </article>
  );
};

export default ServiceCard;
